import React, { useEffect } from 'react';
import { Select, Tooltip, Icon } from 'antd';
import { shutdownNotificationsQuery } from '../../../../../../shared/api/queries';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import {
  compareWithInitVal,
  fieldDataTypes,
} from '../../../../../../shared/lib/formFieldValidators';
import { useNewCityValueSubscription } from '../../../lib/subscriptions';
import styles from './NotifyToField.module.scss';

const { useShutdownNotifications } = shutdownNotificationsQuery;
const { Option } = Select;
const fieldName = fieldNames.notifyTo;
const cityFieldName = fieldNames.city;

const tooltips = new Map([
  // городские службы
  [
    1,
    'отправится уведомление на электронную почту с приложением соответствующего отчета, настроенного в системе',
  ],
  // Собственники
  [
    2,
    'отправится push-уведомление в мобильное приложение собственников, при звонке в аварийно-диспетчерскую службу активируется автоинформатор с сообщением об отключении',
  ],
  // Сотрудники
  [3, 'отправится push-уведомление в мобильное приложение сотрудников'],
]);

const TooltipTitle = ({ items }) => {
  return (
    <ul className={styles.tooltipTitleContainer}>
      {items.map((item) =>
        tooltips.has(item.id) ? (
          <li key={item.id}>
            <b>{item.name}</b> - {tooltips.get(item.id)}
          </li>
        ) : null
      )}
    </ul>
  );
};

const Label = ({ items }) => {
  return (
    <span>
      Отправить уведомление&nbsp;
      {Boolean(items?.length) && (
        <Tooltip title={<TooltipTitle items={items} />}>
          <Icon
            type="info-circle"
            style={{ fontSize: '16px' }}
          />
        </Tooltip>
      )}
    </span>
  );
};

const NotifyToField = ({ form, initialValue, editMode, initCityId }) => {
  const cityDependentData = useNewCityValueSubscription();
  const cityId = editMode ? initCityId : cityDependentData?.[cityFieldName];

  const { data, isFetching } = useShutdownNotifications(cityId, {
    staleTime: Infinity,
    enabled: editMode ? true : Boolean(cityId),
  });

  useEffect(() => {
    if (cityDependentData && !isFetching && data?.length) {
      const value = cityDependentData.hasOwnProperty(fieldName)
        ? cityDependentData[fieldName]
        : form.getFieldValue(fieldName);

      const updatedVal =
        value?.filter((id) => data.some((dataItem) => dataItem.id === id)) ||
        [];

      form.setFieldsValue({ [fieldName]: updatedVal });
    }
  }, [cityDependentData, isFetching, data]);

  return (
    <Field
      fieldType={fieldTypes.select}
      form={form}
      name={fieldName}
      label={<Label items={data} />}
      decoratorOptions={{
        initialValue: data?.length ? initialValue : [],
        rules: editMode
          ? [
              {
                validator: compareWithInitVal(
                  initialValue,
                  fieldDataTypes.array
                ),
              },
            ]
          : [],
      }}
      fieldProps={{
        placeholder: 'Выберите, кому отправить уведомления',
        loading: isFetching,
        mode: 'multiple',
        disabled: !editMode && !cityId,
      }}
      items={data}
      renderOption={(item) => (
        <Option
          key={item.id}
          value={item.id}
        >
          {item.name}
        </Option>
      )}
    />
  );
};

export default NotifyToField;
